<template>
  <div class="vvip-wrap">
    <div class="vvip-frame">
      <div class="vvip-container">
        <div v-for="(vip, index) in allVipInfo" :key="index" :class="{'vvip-card': true, 'active': vip.level_name === currentVipName}">
          <div v-if="rebateInfo && rebateInfo.length > 0" class="title">
            {{ rebateInfo[index+1][0] }}
          </div>
          <div class="card-pic">
            <img :src="vip.image_big" alt="">
          </div>
          <div v-if="tableData && tableData.length > 0" class="card-content">
            <div v-if="tableData[2]" class="content upgrade">
              <div>{{ $t(tableData[2].label) }}</div>
              <div v-if="vip[`${tableData[2].key}_text_enable`]">
                {{ vip[`${tableData[2].key}_text`] }}
              </div>
              <div v-else>
                {{ vip[tableData[2].key] }}
              </div>
            </div>

            <div v-if="tableData[3]" class="content upgrade">
              <div>{{ $t(tableData[3].label) }}</div>
              <div v-if="vip[`${tableData[3].key}_text_enable`]">
                {{ vip[`${tableData[3].key}_text`] }}
              </div>
              <div v-else>
                {{ vip[tableData[3].key] }}
              </div>
            </div>

            <div class="dividers" />

            <div v-if="tableData[0]" class="content">
              <div>{{ $t(tableData[0].label) }}</div>
              <div v-if="vip[`${tableData[0].key}_text_enable`]">
                {{ vip[`${tableData[0].key}_text`] }}
              </div>
              <div v-else>
                {{ vip[tableData[0].key] }}
              </div>
            </div>

            <div v-if="tableData[1]" class="content">
              <div>{{ $t(tableData[1].label) }}</div>
              <div v-if="vip[`${tableData[1].key}_text_enable`]">
                {{ vip[`${tableData[1].key}_text`] }}
              </div>
              <div v-else>
                {{ vip[tableData[1].key] }}
              </div>
            </div>

            <div v-if="tableData[4]" class="content">
              <div>{{ $t(tableData[4].label) }}</div>
              <div v-if="vip[`${tableData[4].key}_text_enable`]">
                {{ vip[`${tableData[4].key}_text`] }}
              </div>
              <div v-else>
                {{ vip[tableData[4].key] }}
              </div>
            </div>

            <template v-if="isThemeGold && staticRebateDataKT">
              <div class="content">
                <div>{{ staticRebateDataKT[0].type }}</div>
                <div>
                  {{ staticRebateDataKT[0].vip_level_rebate_data[index].rates }}
                </div>
              </div>

              <div class="content">
                <div>{{ staticRebateDataKT[1].type }}</div>
                <div>
                  {{ staticRebateDataKT[1].vip_level_rebate_data[index].rates }}
                </div>
              </div>
            </template>
            <template v-else-if="staticRebateDataUB">
              <div class="content">
                <div>{{ staticRebateDataUB[0].type }}</div>
                <div>
                  {{ staticRebateDataUB[0].vip_level_rebate_data[index].rates }}
                </div>
              </div>

              <div class="content">
                <div>{{ staticRebateDataUB[1].type }}</div>
                <div>
                  {{ staticRebateDataUB[1].vip_level_rebate_data[index].rates }}
                </div>
              </div>

              <div class="content">
                <div>{{ staticRebateDataUB[2].type }}</div>
                <div>
                  {{ staticRebateDataUB[2].vip_level_rebate_data[index].rates }}
                </div>
              </div>

              <div class="content">
                <div>{{ staticRebateDataUB[3].type }}</div>
                <div>
                  {{ staticRebateDataUB[3].vip_level_rebate_data[index].rates }}
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>

      <!-- eslint-disable-next-line -->
      <div class="describe-frame" v-html="vipRule"></div>
    </div>
  </div>
</template>

<script>
import { page } from '@/api/common'
import { getAllVipInfo, getAllSpecialVipInfo, getRebateInfo } from '@/api/vip'
import { showNotice } from '@/utils/tool'
import { mapGetters } from 'vuex'
import '@/assets/css/vip.css'

export default {
  data() {
    return {
      allVipInfo: [],
      staticRebateDataKT: [
        {
          type: this.$t('Bao.vip_live_casino'),
          vip_level_rebate_data: [
            { rates: ' 0.15%' }, // VIP0
            { rates: ' 0.35%' }, // VIP1
            { rates: ' 0.40%' }, // VIP2
            { rates: ' 0.45%' }, // VIP3
            { rates: ' 0.55%' }, // VIP4
            { rates: ' 0.60%' }, // VIP5
            { rates: ' 0.65%' }, // VIP6
            { rates: ' 0.70%' }, // VIP7
            { rates: ' 0.95%' }, // VIP8
            { rates: ' 1.00%' } // VIP9
          ]
        },
        {
          type: this.$t('Bao.vip_slots'),
          vip_level_rebate_data: [
            { rates: ' 0.25%' }, // VIP0
            { rates: ' 0.55%' }, // VIP1
            { rates: ' 0.65%' }, // VIP2
            { rates: ' 0.75%' }, // VIP3
            { rates: ' 0.80%' }, // VIP4
            { rates: ' 1.00%' }, // VIP5
            { rates: ' 1.15%' }, // VIP6
            { rates: ' 1.30%' }, // VIP7
            { rates: ' 1.45%' }, // VIP8
            { rates: ' 1.50%' } // VIP9
          ]
        }
      ],
      staticRebateDataUB: [
        {
          type: this.$t('Bao.vip_live_casino'),
          vip_level_rebate_data: [
            { rates: ' 0.2%' }, // VIP0
            { rates: ' 0.3%' }, // VIP1
            { rates: ' 0.3%' }, // VIP2
            { rates: ' 0.3%' }, // VIP3
            { rates: ' 0.4%' }, // VIP4
            { rates: ' 0.4%' }, // VIP5
            { rates: ' 0.4%' }, // VIP6
            { rates: ' 0.5%' }, // VIP7
            { rates: ' 0.5%' }, // VIP8
            { rates: ' 0.5%' }, // VIP9
            { rates: ' 0.6%' }, // VIP10
            { rates: ' 0.6%' }, // VIP11
            { rates: ' 0.6%' }, // VIP12
            { rates: ' 0.7%' }, // VIP13
            { rates: ' 0.7%' }, // VIP14
            { rates: ' 0.7%' } // VIP15
          ]
        },
        {
          type: this.$t('Bao.vip_slots'),
          vip_level_rebate_data: [
            { rates: ' 0.2%' }, // VIP0
            { rates: ' 0.3%' }, // VIP1
            { rates: ' 0.3%' }, // VIP2
            { rates: ' 0.3%' }, // VIP3
            { rates: ' 0.4%' }, // VIP4
            { rates: ' 0.4%' }, // VIP5
            { rates: ' 0.4%' }, // VIP6
            { rates: ' 0.5%' }, // VIP7
            { rates: ' 0.5%' }, // VIP8
            { rates: ' 0.5%' }, // VIP9
            { rates: ' 0.6%' }, // VIP10
            { rates: ' 0.6%' }, // VIP11
            { rates: ' 0.6%' }, // VIP12
            { rates: ' 0.7%' }, // VIP13
            { rates: ' 0.7%' }, // VIP14
            { rates: ' 0.7%' } // VIP15
          ]
        },
        {
          type: this.$t('Bao.vip_sports'),
          vip_level_rebate_data: [
            { rates: ' 0.1%' }, // VIP0
            { rates: ' 0.2%' }, // VIP1
            { rates: ' 0.2%' }, // VIP2
            { rates: ' 0.2%' }, // VIP3
            { rates: ' 0.3%' }, // VIP4
            { rates: ' 0.3%' }, // VIP5
            { rates: ' 0.3%' }, // VIP6
            { rates: ' 0.4%' }, // VIP7
            { rates: ' 0.4%' }, // VIP8
            { rates: ' 0.4%' }, // VIP9
            { rates: ' 0.5%' }, // VIP10
            { rates: ' 0.5%' }, // VIP11
            { rates: ' 0.5%' }, // VIP12
            { rates: ' 0.6%' }, // VIP13
            { rates: ' 0.6%' }, // VIP14
            { rates: ' 0.6%' } // VIP15
          ]
        },
        {
          type: this.$t('Bao.vip_lottery'),
          vip_level_rebate_data: [
            { rates: ' 0.1%' }, // VIP0
            { rates: ' 0.2%' }, // VIP1
            { rates: ' 0.2%' }, // VIP2
            { rates: ' 0.2%' }, // VIP3
            { rates: ' 0.3%' }, // VIP4
            { rates: ' 0.3%' }, // VIP5
            { rates: ' 0.3%' }, // VIP6
            { rates: ' 0.4%' }, // VIP7
            { rates: ' 0.4%' }, // VIP8
            { rates: ' 0.4%' }, // VIP9
            { rates: ' 0.5%' }, // VIP10
            { rates: ' 0.5%' }, // VIP11
            { rates: ' 0.5%' }, // VIP12
            { rates: ' 0.6%' }, // VIP13
            { rates: ' 0.6%' }, // VIP14
            { rates: ' 0.6%' } // VIP15
          ]
        }
      ],
      rebateInfo: [],
      litePlayer: null,
      currentVipLevel: 1,
      selectedVip: {
        key: 0,
        upgrade_prize: 0, // 升級獎勵
        keep_bet_amount_text: 0 // 保級流水
      },
      spec_icon_show: {
        upgrade_money: true,
        monthly_prize: true,
        birthday_prize: true
      },
      vipInfo: {},
      vipRule: ''
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.app.metaInfo.title,
      meta: [
        {
          vmid: 'vip',
          name: 'keywords',
          content: this.$store.state.app.metaInfo.keywords
        }, {
          name: 'description',
          content: this.$store.state.app.metaInfo.description
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['currentTheme']),
    currentVipName() {
      if (!this.$store.state.user ||
          !this.$store.state.user.vipInfo ||
          !this.litePlayer) {
        return ''
      }

      const matchNum = this.$store.state.user.vipInfo.currentVipName.match(/VIP(\d+)/)
      const matchChar = this.rebateInfo.find(array => array[0] === this.$store.state.user.vipInfo.currentVipName)

      if (matchNum) {
        const level = matchNum[1]
        let result = `VIP${level}`
        if (!level) {
          result = 'VIP9'
        }
        this.scrollToHighlighted()
        return result
      }

      if (matchChar) {
        this.scrollToHighlighted()
        return matchChar[0]
      }

      return ''
    },
    tableData() {
      const isShow = false
      const data = [
        {
          label: 'Bao.upgrade_prize_text',
          key: 'upgrade_prize'
        },
        {
          label: 'Bao.birthday_prize_text',
          key: 'birthday_prize'
        },
        {
          label: 'Bao.upgrade_bet_amount_text',
          key: 'upgrade_bet_amount'
        },
        {
          label: 'Bao.upgrade_deposit',
          key: 'upgrade_deposit'
        }]

      if (isShow) {
        data.push({
          label: 'Bao.keep_bet_amount',
          key: 'keep_bet_amount'
        })
      }
      return data
    },
    isThemeGold() {
      return this.currentTheme === 'theme_gold'
    }
  },
  created() {
    getAllVipInfo()
      .then((response) => {
        this.allVipInfo = response.data.data

        this.setCurrentVipLevel()
      })
      .catch((error) => {
        showNotice(error.response.data.msg)
      })
    getAllSpecialVipInfo()
      .then((response) => {
        this.litePlayer = response.data.data
      })
      .catch((error) => {
        showNotice(error.response.data.msg)
      })

    const timestamp = Date.now()
    page({ type: 'vip_rule', timestamp: timestamp }).then(response => {
      this.vipRule = response.data.data.content
    })
    this.scrollToHighlighted()
  },
  mounted() {
    getRebateInfo({ reverse_data: false })
      .then((response) => {
        this.rebateInfo = response.data.data
      })
      .catch((error) => {
        showNotice(error.response.data.msg)
      })
  },
  methods: {
    scrollToHighlighted() {
      this.$nextTick(() => {
        setTimeout(() => {
          const highlightedItem = this.$el.querySelector('.vvip-card.active')
          if (highlightedItem) {
            highlightedItem.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }
        }, 700)
      })
    },
    setCurrentVipLevel() {
      if (!this.$store.state.user ||
          !this.$store.state.user.vipInfo) {
        return
      }

      for (const i in this.allVipInfo) {
        if (this.$store.state.user.vipInfo.currentVipName === this.allVipInfo[i].level_name) {
          this.currentVipLevel = this.allVipInfo[i].level

          this.selectedVip = {
            key: i,
            upgrade_prize: this.allVipInfo[i].upgrade_prize,
            keep_bet_amount_text: this.allVipInfo[i].keep_bet_amount_text
          }
          this.setCurrentVipSpecIcon(this.allVipInfo[i].spec_icon_show)
        }
      }
    },
    setCurrentVipSpecIcon(select_spec_icon_show) {
      if (select_spec_icon_show) {
        this.spec_icon_show.upgrade_money = (select_spec_icon_show.indexOf('upgrade_money') > -1)
        this.spec_icon_show.monthly_prize = (select_spec_icon_show.indexOf('monthly_prize') > -1)
        this.spec_icon_show.birthday_prize = (select_spec_icon_show.indexOf('birthday_prize') > -1)
      } else {
        this.spec_icon_show = {
          upgrade_money: false,
          monthly_prize: false,
          birthday_prize: false
        }
      }
    }
  }
}
</script>

